import styled from 'styled-components';
import {Box} from "@mui/material";
import {breakpoints} from "../../../../../theme";

export const DigitizationToolbarWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 28px 32px;
    flex-shrink: 0;
    gap: 16px;
`;

export const StyledToolbarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;    
    gap: 16px;
    
    @media (max-width: 959px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 22px;
    }
`

export const StyledToolbarHeader = styled(Box)`
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: center;
    gap: 6px;

    @media (max-width: ${breakpoints.sm}) {
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
    }
`;

export const StyledHeaderActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 2;
    gap: 12px;
    width: 100%;
    
    @media (max-width: 399px) {
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
    }
`;